import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=0f3512ac&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"
import style0 from "./Auth.vue?vue&type=style&index=0&id=0f3512ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3512ac",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonsButton: require('/home/runner/work/LTNG-1800-Frontend/LTNG-1800-Frontend/components/Buttons/Button.vue').default})
